import { ActionContext, ActionTree } from "vuex"
import { RootState } from "../../index"
import { MutationType, Mutations } from "./mutations"
import { State } from "./state"

export enum ActionTypes {
    SET_MANUALLY_SELECTED = "SET_MANUALLY_SELECTED",
    SET_SELECTED_DATA_REGION = "SET_SELECTED_DATA_REGION",
    SET_DEFAULT_REGION = "SET_DEFAULT_REGION",
}

type ActionAugments = Omit<ActionContext<State, RootState>, "commit"> & {
    commit<K extends keyof Mutations>(
        key: K,
        payload: Parameters<Mutations[K]>[1]
    ): ReturnType<Mutations[K]>
}

export type Actions = {
    [ActionTypes.SET_MANUALLY_SELECTED](
        { commit }: ActionAugments,
        value: boolean
    ): void
    [ActionTypes.SET_SELECTED_DATA_REGION](
        { commit }: ActionAugments,
        value: string
    ): void
    [ActionTypes.SET_DEFAULT_REGION](
        { commit }: ActionAugments,
        value: string
    ): void
}

export const actions: ActionTree<State, RootState> & Actions = {
    [ActionTypes.SET_MANUALLY_SELECTED]({ commit }, value) {
        commit(MutationType.SET_MANUALLY_SELECTED, value)
    },
    [ActionTypes.SET_SELECTED_DATA_REGION]({ commit }, value) {
        commit(MutationType.SET_SELECTED_DATA_REGION, value)
    },
    [ActionTypes.SET_DEFAULT_REGION]({ commit }, value) {
        commit(MutationType.SET_DEFAULT_REGION, value)
    },
}
